import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { AdviserFcaInput as CleanAdviserFcaInput } from '../../components';

const AdviserFcaInput: React.FC<any> = ({ name, state, ...props }) => {
  const { control } = useFormContext<any>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => <CleanAdviserFcaInput {...field} state={state} {...props} />}
    />
  );
};

export default AdviserFcaInput;
